import { render, staticRenderFns } from "./StatusIndicatorText.vue?vue&type=template&id=3b5b6bb6"
import script from "./StatusIndicatorText.vue?vue&type=script&lang=js"
export * from "./StatusIndicatorText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports